import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commentCount',
    pure: false
})
export class CommentCountPipe implements PipeTransform {
    transform(rcaData: any, hypothesisIndex?: number): number {
        let hypothesisList = rcaData.data[0].data
        if (!hypothesisList.length) {
            return 0;
        }
        if (hypothesisIndex !== undefined && hypothesisIndex !== null) {
            const hypothesis = hypothesisList[hypothesisIndex];
            if (!hypothesis) {
                return 0;
            }
            let count = 0;
            // Count header comments
            count += hypothesis.comments?.length || 0;
            // Count causal chain comments
            if (hypothesis.causal_chain) {
                hypothesis.causal_chain.forEach((causal: any) => {
                    count += causal.comments?.length || 0;
                });
            }
            // Count recommendation comments
            if (hypothesis.recommendations) {
                hypothesis.recommendations.forEach((rec: any) => {
                    count += rec.comments?.length || 0;
                });
            }

            return count;
        }

        // If hypothesisIndex is null/undefined, calculate total comments across all hypotheses
        let totalCount = 0;
        if (hypothesisList && hypothesisList.length) {
            hypothesisList.forEach((hypothesis: any) => {
                // Header comments
                totalCount += hypothesis.comments?.length || 0;

                // Causal chain comments
                if (hypothesis.causal_chain) {
                    hypothesis.causal_chain.forEach((causal: any) => {
                        totalCount += causal.comments?.length || 0;
                    });
                }

                // Recommendation comments
                if (hypothesis.recommendations) {
                    hypothesis.recommendations.forEach((rec: any) => {
                        totalCount += rec.comments?.length || 0;
                    });
                }
            });
        }
        return totalCount;
    }
}